import { ACTION_TYPES } from 'src/constants';

export function updateSavingPlan(payload) {
  return {
    type: ACTION_TYPES.UPDATE_SAVING_PLAN,
    payload,
  };
}
